import { Stack, Typography } from '@mui/material';
import {
  ControllerDatePicker,
  CustomRadioGroup,
  RadioButtons,
} from 'Components';
import { SpecialCaseNote } from '../SpecialCaseNote';
import { useAppSelector, useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useWatch } from 'react-hook-form';
import { isAfter } from 'date-fns';
import { yesNoOptions } from 'Constants';

export const CAREER_MILITARY_SERVICE = 2;
export const DiagnosisExist = () => {
  const { index } = useContext(IndexContext);

  const [diseaseOptions] = useAppSelector(
    ({
      generalContent: {
        generalContent: { diseaseOptions },
      },
    }) => [diseaseOptions]
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}.diseaseKindSection`;

  const caseTypeSection = useWatch({
    name: `caseDetails.${index}.caseTypeSection`,
  });

  const serviceTypeId = useWatch({
    name: `caseDetails.${index}.militaryServiceSection.serviceTypeId`,
  });

  const [isDiagnosisExist, diseaseDiagnosisDate] = useWatch({
    name: [`${baseName}.isDiagnosisExist`, `${baseName}.diseaseDiagnosisDate`],
  });

  return (
    <>
      <Stack>
        <Typography sx={{ fontWeight: 'bold' }}>
          {dictionary.secondSectionMentalTitleQ}
        </Typography>
        <RadioButtons
          id={dictionary.secondSectionMentalIsThereDiagnosis}
          name={`${baseName}.isDiagnosisExist`}
          options={yesNoOptions}
        />
      </Stack>
      {isDiagnosisExist && (
        <>
          <br />
          <ControllerDatePicker
            name={
              `${baseName}.diseaseDiagnosisDate` as `caseDetails.0.diseaseKindSection.diseaseDiagnosisDate`
            }
            label={dictionary.secondSectionMentalWhenDiagnosis}
          />
          {diseaseDiagnosisDate &&
            isAfter(diseaseDiagnosisDate, new Date('2013-12-31')) && (
              <>
                {caseTypeSection.isDisease &&
                  serviceTypeId === CAREER_MILITARY_SERVICE && (
                    <>
                      <SpecialCaseNote />
                      <CustomRadioGroup
                        id={dictionary.secondSectionDiseaseSickQ}
                        name={`${baseName}.diseaseOptionId` as const}
                        options={diseaseOptions.map(({ id, value }) => ({
                          value: id.toString(),
                          label: value,
                        }))}
                        sx={{
                          gap: '10px',
                        }}
                      />
                    </>
                  )}
              </>
            )}
        </>
      )}
    </>
  );
};
